import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import React, {ReactNode} from 'react';

interface Props {
    suit: string
    sign: string
    additionClassName?: string
}

export default class PokerCard extends React.Component<Props> {
    render(): ReactNode {
        const {suit, sign, additionClassName} = this.props;

        return <div className={`poker-card ${suit}${additionClassName}`}>
            <span className="dignity">{sign}</span>
            <span className="suit">
                <SpriteIcon name={`#svg-card-${suit}`} className="svg-default" />
            </span>
        </div>;
    }
}
